export var buildEnv = {
    buildMode: 'release',
    sdkVersion: '4.2.0',
};
//# sourceMappingURL=buildEnv.js.map